import { Application, Controller } from "@hotwired/stimulus";

class ApplicationPurchaseController extends Controller {
  static targets = ['total', 'unitField']

  initialize() {
    this.price = Number(this.element.dataset.price);
  }

  connect() {
    this.setTotal(this.unitFieldTarget.value);
  }

  changeUnit(event) {
    this.setTotal(event.target.value);
  }

  setTotal(unit) {
    this.totalTarget.textContent = `${unit}枚`;
  }

  get_total_price(unit) {
    return unit * 10000
  }
}

// Registered in admin.js
export { ApplicationPurchaseController };
